export default __webpack_public_path__ + "static/media/settingIcon1.48250b09.svg";